import { NewContextMenu } from '../ReactControls/contextMenus/NewContextMenu';
import { ReactToRactiveAdapter } from '../ReactToRactiveAdapter';
export class NewContextMenuRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
    static show(props) {
        NewContextMenuRactive.hide();
        NewContextMenuRactive.instance = new NewContextMenuRactive();
        NewContextMenuRactive.instance.set(props);
        const mountElement = document.getElementById('newContextMenu');
        NewContextMenuRactive.instance.render(mountElement);
    }
    static hide() {
        if (!isNullOrUndefined(NewContextMenuRactive.instance)) {
            NewContextMenuRactive.instance.teardown();
            NewContextMenuRactive.instance = null;
        }
    }
    static isVisible() {
        return !isNullOrUndefined(NewContextMenuRactive.instance);
    }
}
NewContextMenuRactive.instance = null;
ReactToRactiveAdapter.extendWith(NewContextMenuRactive, {
    template: '<div class="new-context-menu-wrapper"></div>',
    mountContainer: '.new-context-menu-wrapper',
    reactComponent: NewContextMenu,
    data: function () {
        return {
            props: {}
        };
    }
});
global.showContextMenu = NewContextMenuRactive.show;
global.hideContextMenu = NewContextMenuRactive.hide;
global.isVisibleContextMenu = NewContextMenuRactive.isVisible;
